import React, { useContext, useEffect, useState } from "react";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalHeader from "../../../../components/Modal/ModalHeader";

import ModalFooter from "../../../../components/Modal/ModalFooter";
import { t } from "i18next";
import userContext from "../../../../context/users/UserContext";
import toastContext from "../../../../context/toast/ToastContext";
import themeContext from "../../../../context/theme/ThemeContext";
import { Icon, Spinner, SpinnerSize, TextField } from "@fluentui/react";
import {
  getTypistInfo,
  unassignTypist,
} from "../../../../service/StudyListService";
import loaderContext from "../../../../context/loader/LoaderContext";
import { MODAL_TYPE, TOAST_TYPE } from "../../../../constants/Constants";
const TypistAccessCode = (props) => {
  const [accessCode, setAccessCode] = useState("");
  const [typistName, setTypistName] = useState("");
  const { showToastv2 } = useContext(toastContext);
  const [loading, setLoading] = useState(false);
  
  const { showModal, setShowModal } = useContext(loaderContext);
  const { studyId, setShowTypistModal } = props;
  const handleTypistModal = async () => {
    try {
      setLoading(true);
      const response = await getTypistInfo(studyId);

      if (response.status == 200) {
        if (response.data.result == "SUCCESS") {
          setAccessCode(response.data.data.accessCode);

          setTypistName(
            response.data.data.typistName == null
              ? "-"
              : response.data.data.typistName
          );
        } else {
          setShowTypistModal(false);
          setShowModal(() => {
            const newItem = { ...showModal };
            newItem.show = true;
            newItem.type  = MODAL_TYPE.ALERT_MODAL;
            newItem.heading = "Alert";
            newItem.description =  response.data.message;
            return newItem;
          });
        }
        setLoading(false);
      } else {
        setShowTypistModal(false);
        setLoading(false);
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
      }
    } catch (e) {
      setShowTypistModal(false);
      setLoading(false);
      showToastv2(TOAST_TYPE.ERROR, t("string-literals.error-msg"));
    }
  };
  useEffect(() => {
    if (studyId != null) {
      handleTypistModal();
    }
  }, [studyId]);

  const handleunassignTypistModal = async () => {
    const response = await unassignTypist(studyId);
    if (response.status == 200) {
      if (response.data.result == "SUCCESS") {
        showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
        setShowTypistModal(false);
      } else {
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
      }
    }
  };

  let DefaultButtonList = [
    {
      title: t("typist-info.btn-unassign-typist"),
      onclick: () => {
        handleunassignTypistModal();
      },
    },
  ];

  let PrimaryButtonList = [
    {
      title: "Close",
      onclick: () => {
        setShowTypistModal(false);
      },
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("typist-info.title")}
        handleCancel={() => {
          setShowTypistModal(false);
        }}
      />
    ),
    body: (
      <TypistAccessCodeBody
        loading={loading}
        accessCode={accessCode}
        typistName={typistName}
        isTypistWorkflowEnabled={props.isTypistWorkflowEnabled}
      />
    ),
    footer: (
      <ModalFooter
        DefaultButtonList={
          loading ||  typistName == null || typistName == "-" ? [] : DefaultButtonList
        }
        PrimaryButtonList={PrimaryButtonList}
      />
    ),
    width: "600px",
  };
  return (
    <>
      {true && (
        <ModalMain
          updatedModal={true}
          modalDetails={modalDetails}
          showModal={true}
        />
      )}
    </>
  );
};

export default TypistAccessCode;

export const TypistAccessCodeBody = ({ accessCode, loading, typistName, isTypistWorkflowEnabled }) => {
 
  const { getAlterColor, getThemeColor } = useContext(themeContext);
  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const textFieldStyle = {
    fieldGroup: {
      "&.is-disabled": {
        background: "transparent !important",
        border: "1px solid rgba(200, 198, 196, 0.3) !important",
        cursor: "not-allowed",
      },
    },
    root: {
      width: "80%",
      borderRadius: "7px",
      marginRight: "1rem",
      "&.is-disabled": {
        backgroundColor: "transparent !important",
        cursor: "not-allowed",
        border: "none !important",
      },
    },
    field: {
      backgroundColor: "transparent !important",
      border: "1px solid rgba(200, 198, 196, 0.3) !important",
      fontFamily:"Consolas !important",
    },
  };

  const handleCopyUrl = () => {
    let hiddenMessage = document.getElementById("copied-msg");
    let copyText = document.getElementById("accessCode");
    copyText.select();
    copyText.setSelectionRange(0, 99999);

    navigator.clipboard.writeText(copyText.value);
    hiddenMessage.style.visibility = "visible";
  };
  return (
    <div
      style={{
        display: "flex",
        padding: "20px",
        flexDirection: "column",
        gap: "2rem",
      }}
    >
      {loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : (
        <React.Fragment>
          <>
            <div style={{ display: "flex" }}>
              <div style={{ marginRight: "10px" }}>
                <label style={{ color: getThemeColor("primary-color") }}>
                  {t("typist-info.typist-name")}
                </label>
              </div>
              <span name="typistName">{typistName}</span>
            </div>
            {(isTypistWorkflowEnabled == 1) && (<div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex" }}>
                <div style={{ marginRight: "10px", whiteSpace: "nowrap" }}>
                  <label style={{ color: getThemeColor("primary-color") }}>
                    {t("typist-info.access-code")}
                  </label>
                </div>
                <TextField
                  className="textArea"
                  name="accessCode"
                  id="accessCode"
                  styles={textFieldStyle}
                  disabled
                  value={accessCode}
                />{" "}
                <div
                  style={{
                    display: "flex",
                    alignItems: "start",
                    marginTop: "5px",
                    marginRight: "5px",
                  }}
                >
                  <Icon
                    iconName="copy"
                    style={{
                      fontSize: "20px",
                      color: getAlterColor("#ffffffad", ""),
                      cursor: "pointer",
                    }}
                    onClick={handleCopyUrl}
                  ></Icon>
                </div>
              </div>
              
              <div>
                <span
                  className="copied-msg"
                  id="copied-msg"
                  style={{ marginLeft: "15%" }}
                  color={getAlterColor("green","#0078d4")}
                >
                  {t("typist-info.code-copied-successfully")}!!
                </span>
              </div>

            </div>
            )}
          </>
        </React.Fragment>
      )}
    </div>
  );
};
